import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { types, initialState } from './types'

export const fetchPrescriptions = () => ({
  [RSAA]: {
    endpoint: getApiPath('care', 'prescriptions'),
    method: 'GET',
    body: JSON.stringify(),
    types: [
      types.FETCH_PRESCRIPTIONS_REQUEST,
      types.FETCH_PRESCRIPTIONS_SUCCESS,
      types.FETCH_PRESCRIPTIONS_ERROR,
    ],
    cache: true,
  },
})

export const fetchPrescriptionsByKeyword = keyword => ({
  [RSAA]: {
    endpoint: getApiPath(
      'care',
      `drugs/pub/suggest?drugNamePrefix=${keyword}&uniqueTitle=true`,
    ),
    headers: {
      tz: 'IGNORE',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
    method: 'GET',
    types: [
      types.FETCH_RX_BY_KEYWORD_REQUEST,
      types.FETCH_RX_BY_KEYWORD_SUCCESS,
      types.FETCH_RX_BY_KEYWORD_ERROR,
    ],
    cache: true,
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_RX_BY_KEYWORD_REQUEST:
    case types.FETCH_PRESCRIPTIONS_REQUEST: {
      return {
        ...state,
        prescriptions: {
          ...state.prescriptions,
          busy: true,
          error: '',
        },
      }
    }

    case types.FETCH_PRESCRIPTIONS_SUCCESS:
    case types.FETCH_RX_BY_KEYWORD_SUCCESS: {
      return {
        ...state,
        prescriptions: {
          busy: false,
          entities: payload.content,
        },
      }
    }

    case types.FETCH_RX_BY_KEYWORD_ERROR:
    case types.FETCH_PRESCRIPTIONS_ERROR: {
      return {
        ...state,
        prescriptions: {
          busy: false,
          error: payload.response.message,
        },
      }
    }

    default:
      return state
  }
}
